var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3335_20579",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.891357,
    y: 0.445618,
    width: 24,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3335_20579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4914 16.4456C11.4914 15.0956 11.6122 14.1248 11.8539 13.5331C12.0956 12.9415 12.6081 12.2956 13.3914 11.5956C14.0747 10.9956 14.5956 10.4748 14.9539 10.0331C15.3122 9.59145 15.4914 9.08728 15.4914 8.52062C15.4914 7.83728 15.2622 7.27062 14.8039 6.82062C14.3456 6.37062 13.7081 6.14562 12.8914 6.14562C12.0414 6.14562 11.3956 6.40395 10.9539 6.92062C10.5122 7.43728 10.1997 7.96228 10.0164 8.49562L7.44141 7.39562C7.79141 6.32895 8.43307 5.40395 9.36641 4.62062C10.2997 3.83728 11.4747 3.44562 12.8914 3.44562C14.6414 3.44562 15.9872 3.93312 16.9289 4.90812C17.8706 5.88312 18.3414 7.05395 18.3414 8.42062C18.3414 9.25395 18.1622 9.96645 17.8039 10.5581C17.4456 11.1498 16.8831 11.8206 16.1164 12.5706C15.2997 13.354 14.8039 13.9498 14.6289 14.3581C14.4539 14.7665 14.3664 15.4623 14.3664 16.4456H11.4914ZM12.8914 22.4456C12.3414 22.4456 11.8706 22.2498 11.4789 21.8581C11.0872 21.4665 10.8914 20.9956 10.8914 20.4456C10.8914 19.8956 11.0872 19.4248 11.4789 19.0331C11.8706 18.6415 12.3414 18.4456 12.8914 18.4456C13.4414 18.4456 13.9122 18.6415 14.3039 19.0331C14.6956 19.4248 14.8914 19.8956 14.8914 20.4456C14.8914 20.9956 14.6956 21.4665 14.3039 21.8581C13.9122 22.2498 13.4414 22.4456 12.8914 22.4456Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question_mark.2b9a5235bc2f95e1154219cfcf98afd3.svg";
export { ForwardRef as ReactComponent };